import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useLocation,
} from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import "react-calendar/dist/Calendar.css";
import "antd/dist/antd.css";

// REDUX
import { selectUser } from "./_redux/initializeAppSlice";
import { onChangeSearchBar } from "./_redux/searchBarSlice";

// COMPONENTS
import { BuroMainTwo as BuroMain } from "components/BuroBug/BuroMainTwo";
import Sidebar from "./components/Layout/Sidebar";
import DashboardMain from "./components/Dashboard/DashboardMain";
import DashboardTest from "./components/Views/DashboardMain";
import Navbar from "./components/Layout/Navbar";
import CardTable from "../src/components/Cards/CardTable";
import Image from "./components/Image/Image";
import LoanRequest from "./components/LoanRequest/LoanRequestMain";
import GiftRequest from "./components/GiftRequest/GiftRequestMain";
import Gift from "./components/Gift/GiftMain";
import TransferLoanMain from "./components/TransferLoan/TransferLoanMain";
import OverDueAlertMain from "./components/OverDueAlert/OverDueAlertMain";
import ReportMain from "./components/Report/ReportMain";
import ContractManagementMain from "./components/ContractManagement/ContractManagementMain";
import Refinance from "./components/Refinance/RefinanceMain";
import Login from "components/Home/Login";
import ProtectedRoute from "components/Route/ProtectedRoute";
import Loading from "components/Loading/LoadingPage";
import Loan from "components/Loan/LoanMain";
import SettingsMain from "components/Settings/SettingsMain";
import LoanId from "components/Loan/LoanId";
import BroadCast from "components/BroadCast/BroadCastMain";
import BroadCastId from "components/BroadCast/BroadCastId";
import ChatBot from "components/ChatBot/ChatBotMain";
import CreditBuro from "components/CreditBuro/buro";
import ResetPassword from "components/Home/ResetPassword";
import LoanSandbox from "./components/LoanSandbox/LoanMainSandbox";
import Sandbox from "components/Sandbox/sandbox";
import LoanSandboxId from "./components/LoanSandbox/LoanSandboxId";
import SapMain from "./components/Sap/SapMain";
import InterfaceCreate from "components/InterfaceCreate/InterfaceCreateMain";
import ModelMain from "./components/Model/ModelMain";
import LeasingSandboxMain from "./components/Leasing/LeasingSandboxMain";
import LeasingRequestMain from "./components/Leasing/LeasingRequestMain";
import ContactBookMain from "./components/ContactBook/ContactBookMain";
import LeasingLoanMain from "./components/Leasing/LeasingLoanMain";
import LeasingLoanInfoMain from "./components/Leasing/LeasingLoanInfoMain";
import LeasingSettingInterestMain from "./components/Leasing/LeasingSettingInterestMain";
import LeasingSettingGroup from "./components/Leasing/LeasingSettingGroup";
import LeasingCreditBuro from "./components/Leasing/LeasingCreditBuroMain";
import ImportAccruedInterest from "./components/ImportTriggerAccrued/importTriggerAccried";
import LeasingReportMain from "./components/Leasing/LeasingReportMain";

// CONTEXT
import SearchBarProvider from "./context/SearchBarContext";
import TabSideBarProvider from "./context/TabSidebarContext";

// STYLES
import "./styles/global.css";

// AWS
// import awsconfig from "./aws-exports";
import Amplify, { Auth, Storage } from "aws-amplify";
import AccruedInterest from "./components/AccruedInterest/AccruedInterest";
import Sandbox5 from "components/Sandbox5/sandbox5";
import Sandbox6 from "components/Sandbox6/sandbox6";
import LoanLeasing from "Leasing/loanLeasing";
import { LoanLeasingInfo } from "Leasing/views/LoanLeasingInfo";
import PdfViewerMain from "./components/PdfViewer/PdfViewerMain";
import LeasingSandboxInfoMain from "./components/Leasing/LeasingSandboxInfoMain";
import LeasingDashboardMain from "components/Leasing/LeasingDashboardMain";

Storage.configure({
  bucket: "imagestorage232737-production", //REQUIRED -  Amazon S3 bucket name
  region: "ap-southeast-1", //OPTIONAL -  Amazon service region
  identityPoolId: "ap-southeast-1:f276e9e7-023b-4ab1-8bef-e6c9da6a3ace",
});

//custom
// Amplify.configure(awsconfig);
Amplify.configure({
  API: {
    endpoints: [
      {
        name: "MoneyHubAdmin",
        endpoint: "https://api.moneyhubservice.com",
      },
    ],
  },
  Auth: {
    // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
    identityPoolId: "ap-southeast-1:f276e9e7-023b-4ab1-8bef-e6c9da6a3ace",
    // REQUIRED - Amazon Cognito Region
    region: "ap-southeast-1",

    // OPTIONAL - Amazon Cognito Federated Identity Pool Region
    // Required only if it's different from Amazon Cognito Region
    identityPoolRegion: "ap-southeast-1",

    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: "ap-southeast-1_E1FPtKy2R",

    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: "3f9imvr0pqbg2kl54ceid1f4ob",

    // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
    mandatorySignIn: false,
  },
  Storage: {
    AWSS3: {
      bucket: "imagestorage232737-production", //REQUIRED -  Amazon S3 bucket name
      region: "ap-southeast-1", //OPTIONAL -  Amazon service region
    },
  },
});

// You can get the current config object
//const currentConfig = Auth.configure();

function App() {
  const { user, status } = useSelector((state) => state.initializeApp);
  const [showSidebar, setShowSidebar] = useState(true);

  // console.warn = function filterWarnings() {};

  if (status === "loading") {
    return <Loading />;
  }

  return (
    <Router>
      <SearchBarProvider>
        <TabSideBarProvider>
          {user && (
            <React.Fragment>
              <Sidebar
                setShowSidebar={setShowSidebar}
                showSidebar={showSidebar}
              />
              <div
                className={
                  "hidden md:block relative " + (showSidebar ? "md:ml-64" : "")
                }
              >
                <Navbar />
              </div>
            </React.Fragment>
          )}
          <Switch>
            <Route path="/login" component={Login} />
            <Route path="/resetPassword" component={ResetPassword} />
            <Route
              path={`/contactBook/:citizenid`}
              component={ContactBookMain}
            />

            {/* <Route exact path="/image/:imgKey" component={Image} /> */}
            <div className={"relative " + (showSidebar ? "md:ml-64" : "")}>
              <ProtectedRoute
                exact
                path="/"
                component={DashboardMain}
                groups={[
                  "SuperAdmin",
                  "Marketing",
                  "Analyze",
                  "AnalyzeApprove",
                  "ApproveStaff",
                  "ApproveSupervisor",
                  "BusinessDevelopment",
                  "CustomerService",
                  "Admin",
                ]}
              />

              <ProtectedRoute
                exact
                path="/LoanSandbox"
                component={LoanSandbox}
                groups={[
                  "SuperAdmin",
                  "CustomerService",
                  "Admin",
                  "BusinessDevelopment",
                ]}
              />

              <ProtectedRoute
                exact
                path="/importAccrued"
                component={ImportAccruedInterest}
                groups={[
                  "SuperAdmin",
                  "BusinessDevelopment",
                  "CustomerService",
                  "Admin",
                ]}
              />

              {/* <ProtectedRoute
              exact
              path="/accruedInterest"
              component={AccruedInterest}
              groups={["SuperAdmin"]}
            /> */}

              <ProtectedRoute
                exact
                path="/LoanSandbox/:loan_id"
                component={LoanSandboxId}
                groups={[
                  "SuperAdmin",
                  "CustomerService",
                  "Admin",
                  "BusinessDevelopment",
                ]}
              />

              <ProtectedRoute
                exact
                path="/pdf"
                component={PdfViewerMain}
                groups={["SuperAdmin"]}
              />

              <ProtectedRoute
                exact
                path="/buro"
                component={BuroMain}
                groups={["SuperAdmin", "CustomerService", "Admin", "Debt"]}
              />

              {/* <ProtectedRoute
              exact
              path="/Sandbox"
              component={Sandbox}
              groups={["SuperAdmin", "Marketing", "Analyze", "AnalyzeApprove"]}
            /> */}

              <ProtectedRoute
                path="/leasingSettingsGroup/:category"
                component={LeasingSettingGroup}
                groups={["SuperAdmin"]}
              />

              <ProtectedRoute
                exact
                path="/chatBot"
                component={ChatBot}
                groups={["SuperAdmin", "CustomerService", "Admin", "Marketing"]}
              />

              <ProtectedRoute
                path="/leasingDashboard"
                component={LeasingDashboardMain}
                groups={[
                  "SuperAdmin",
                  "Marketing",
                  "Analyze",
                  "AnalyzeApprove",
                  "ApproveStaff",
                  "ApproveSupervisor",
                  "BusinessDevelopment",
                  "CustomerService",
                  "Admin",
                ]}
              />

              <ProtectedRoute
                path="/leasingRequest"
                component={LeasingRequestMain}
                groups={[
                  "SuperAdmin",
                  "Analyze",
                  "AnalyzeApprove",
                  "CustomerService",
                  "Admin",
                  "Debt",
                  "ApproveStaff",
                  "ApproveSupervisor",
                  "CollectionStaff",
                  "CollectionSupervisor",
                  "BusinessDevelopment",
                  "Litigation",
                  "Marketing",
                  "Admin",
                ]}
              />

              <ProtectedRoute
                path="/leasingTransferLoan"
                component={LeasingRequestMain}
                groups={[
                  "SuperAdmin",
                  "CustomerService",
                  "Admin",
                  "Litigation",
                ]}
              />

              <ProtectedRoute
                // exact
                path="/leasingLoan"
                component={LeasingLoanMain}
                groups={[
                  "SuperAdmin",
                  "CustomerService",
                  "Admin",
                  "Marketing",
                  "AnalyzeApprove",
                  "Analyze",
                  "Debt",
                  "ApproveStaff",
                  "ApproveSupervisor",
                  "CollectionStaff",
                  "CollectionSupervisor",
                  "BusinessDevelopment",
                  "Litigation",
                ]}
              />

              <ProtectedRoute
                exact
                path="/leasingInfo/:loan_id"
                component={LeasingLoanInfoMain}
                groups={[
                  "SuperAdmin",
                  "CustomerService",
                  "Admin",
                  "Marketing",
                  "AnalyzeApprove",
                  "Analyze",
                  "Debt",
                  "ApproveStaff",
                  "ApproveSupervisor",
                  "CollectionStaff",
                  "CollectionSupervisor",
                  "BusinessDevelopment",
                  "Litigation",
                ]}
              />

              <ProtectedRoute
                path="/leasingSandbox/:category"
                component={LeasingSandboxMain}
                groups={[
                  "SuperAdmin",
                  "CustomerService",
                  "Admin",
                  "BusinessDevelopment",
                ]}
              />

              <ProtectedRoute
                path="/leasingSandboxInfo/:loan_id"
                component={LeasingSandboxInfoMain}
                groups={[
                  "SuperAdmin",
                  "CustomerService",
                  "Admin",
                  "BusinessDevelopment",
                ]}
              />

              <ProtectedRoute
                path="/leasingSettings"
                component={LeasingSettingInterestMain}
                groups={["SuperAdmin"]}
              />

              <ProtectedRoute
                path="/sandbox5"
                component={Sandbox5}
                groups={[
                  "SuperAdmin",
                  "CustomerService",
                  "Admin",
                  "BusinessDevelopment",
                ]}
              />

              <ProtectedRoute
                path="/sandbox6"
                component={Sandbox6}
                groups={[
                  "SuperAdmin",
                  "CustomerService",
                  "Admin",
                  "BusinessDevelopment",
                ]}
              />

              <ProtectedRoute
                path="/loanRequest"
                component={LoanRequest}
                groups={[
                  "SuperAdmin",
                  "Analyze",
                  "AnalyzeApprove",
                  "CustomerService",
                  "Admin",
                  "Debt",
                  "ApproveStaff",
                  "ApproveSupervisor",
                  "CollectionStaff",
                  "CollectionSupervisor",
                  "BusinessDevelopment",
                  "Litigation",
                  "Marketing",
                  "Admin",
                  "RefinanceStaff",
                ]}
              />

              {/* <ProtectedRoute
              path="/interfaceCreate"
              component={InterfaceCreate}
              groups={["SuperAdmin"]}
            /> */}

              <ProtectedRoute
                exact
                path="/broadCast/:type"
                component={BroadCast}
                groups={[
                  "Admin",
                  "SuperAdmin",
                  "Marketing",
                  "Debt",
                  "CollectionStaff",
                  "CollectionSupervisor",
                  "CustomerService",
                ]}
              />

              <ProtectedRoute
                exact
                path="/broadCast/info/:broadCastId"
                component={BroadCastId}
                groups={[
                  "Admin",
                  "SuperAdmin",
                  "Marketing",
                  "Debt",
                  "CollectionStaff",
                  "CollectionSupervisor",
                  "CustomerService",
                ]}
              />

              <ProtectedRoute
                exact
                path="/creditBuro"
                component={CreditBuro}
                groups={["SuperAdmin", "CustomerService", "Admin", "Debt"]}
              />

              <ProtectedRoute
                exact
                path="/leasingCreditBuro"
                component={LeasingCreditBuro}
                groups={["SuperAdmin", "CustomerService", "Admin", "Debt"]}
              />

              <ProtectedRoute
                exact
                path="/leasingReport"
                component={LeasingReportMain}
                groups={[
                  "SuperAdmin",
                  "Marketing",
                  "Analyze",
                  "AnalyzeApprove",
                  "Debt",
                  "CustomerService",
                  "Admin",
                  "ApproveSupervisor",
                  "CollectionSupervisor",
                  "BusinessDevelopment",
                  "Litigation",
                ]}
              />

              <ProtectedRoute
                exact
                path="/loan"
                component={Loan}
                groups={[
                  "SuperAdmin",
                  "CustomerService",
                  "Admin",
                  "Marketing",
                  "AnalyzeApprove",
                  "Analyze",
                  "Debt",
                  "ApproveStaff",
                  "ApproveSupervisor",
                  "CollectionStaff",
                  "CollectionSupervisor",
                  "BusinessDevelopment",
                  "Litigation",
                  "RefinanceStaff"
                ]}
              />

              <ProtectedRoute
                exact
                path="/loan/:loan_id"
                component={LoanId}
                groups={[
                  "SuperAdmin",
                  "CustomerService",
                  "Admin",
                  "Marketing",
                  "AnalyzeApprove",
                  "Debt",
                  "ApproveStaff",
                  "ApproveSupervisor",
                  "CollectionStaff",
                  "CollectionSupervisor",
                  "BusinessDevelopment",
                  "Litigation",
                  "RefinanceStaff"
                ]}
              />

              <ProtectedRoute
                path="/settings"
                component={SettingsMain}
                groups={["SuperAdmin"]}
              />

              <ProtectedRoute
                path="/model"
                component={ModelMain}
                groups={["SuperAdmin"]}
              />

              <ProtectedRoute
                path="/gift"
                component={Gift}
                groups={["SuperAdmin", "Marketing"]}
              />

              <ProtectedRoute
                path="/giftRequest"
                component={GiftRequest}
                groups={["SuperAdmin", "CustomerService", "Admin", "Marketing"]}
              />

              <ProtectedRoute
                path="/transferLoan"
                component={TransferLoanMain}
                groups={[
                  "SuperAdmin",
                  "CustomerService",
                  "Admin",
                  "Litigation",
                ]}
              />

              <ProtectedRoute
                path="/report"
                component={ReportMain}
                groups={[
                  "SuperAdmin",
                  "Marketing",
                  "Analyze",
                  "AnalyzeApprove",
                  "Debt",
                  "CustomerService",
                  "Admin",
                  "ApproveSupervisor",
                  "CollectionSupervisor",
                  "BusinessDevelopment",
                  "Litigation",
                ]}
              />

              <ProtectedRoute
                path="/sap"
                component={SapMain}
                groups={[
                  "SuperAdmin",
                  "BusinessDevelopment",
                  "CustomerService",
                  "Admin",
                ]}
              />
            </div>
          </Switch>
        </TabSideBarProvider>
      </SearchBarProvider>
    </Router>
  );
}

export default App;
